export const changePassword = {
  changeCurrentPassword: "Contraseña actual",
  changeNewPassword: "Contraseña nueva",
  changeConfirmNewPassword: "Confirmar Contraseña nueva",
  changePasswordMessage: "¡Por favor introduzca su contraseña!",
  changePasswordError: "La contraseña no coincide!",
  changePasswordBtn: "Enviar",
};
